<template>
  <SimpleField
    :disabled="disabled"
    :operators="operators"
    :value.sync="mutableValue"/>
</template>
<script>
import SimpleField from 'components/automation/conditions/default/simpleField.vue'

/**
 * 14
 */
export default {
  name: 'tenderLotsCount',
  computed: {
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  components: {
    SimpleField
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
